import BackButton from "components/Common/BackButton"
import { Link } from "react-router-dom"

const NotFound = () => {
  return (
    <div className="vh-100 d-flex flex-column justify-content-center align-items-center text-center bg-light">
      <div className="mb-4">
        {/* Trendy 2025 UI icon */}
        <i className="fas fa-exclamation-triangle fa-6x text-danger mb-3"></i>
        <h1 className="display-1 fw-bold text-dark">404</h1>
      </div>
      <h2 className="fs-3 fw-semibold text-secondary mb-3">
        Oops! Page Not Found
      </h2>
      <p className="text-muted mb-4">
        The page you are looking for doesn’t exist, has been moved, or you don’t
        have access.
      </p>
      <BackButton />
    </div>
  )
}

export default NotFound
